<template>
  <div class="pdf-thumbnail">
    <img :src="previewImageUrl" class="preview-image" :alt="name" />
    <div class="overlay">
      <i class="fas fa-file-pdf"></i>
      <span>{{ name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PdfThumbnail',
  props: {
    pdfUrl: {
      type: String,
      required: true
    },
    previewImageUrl: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: 'Документ PDF'
    }
  }
};
</script>

<style scoped>
.pdf-thumbnail {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
  border-radius: 12px 12px 0 0;
  background-color: #f5f5f5;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
  transition: transform 0.3s ease;
}

.pdf-thumbnail:hover .preview-image {
  transform: scale(1.05);
}

.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  backdrop-filter: blur(2px);
}
</style>
